<template>
    <div>
        <el-form ref="addForm" :model="addForm" :rules="rules" label-width="100px">
            <el-row v-if="this.isEdit === 'edit' || this.isEdit === 'add'">
                <el-col :span="6">
                    <el-form-item label="文章标题" prop="title" class="formItem">
                        <el-input v-model="addForm.title" clearable placeholder="请输入" maxlength="20"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="this.isEdit === 'view'" style="text-align:center;font-size:30px">{{addForm.title}}</el-row>
            <el-row v-if="this.isEdit === 'edit' || this.isEdit === 'add'">
                    <el-form-item label="内容" prop="content" class="formItem">
                        <vueQuillEditor @handleQuillEditor="handleQuillEditor" ref="vueQuillEditor"></vueQuillEditor>
                    </el-form-item>
            </el-row>
            <el-row v-if="this.isEdit === 'view'">
                <div v-html="addForm.content" style="padding:20px"></div>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align:center">
            <el-button @click="closeData">返回</el-button>
            <el-button type="primary" @click="addEventForm()" v-if="this.isEdit !== 'view'">保 存</el-button>
        </div>
    </div>
</template>
<script>
import { Message } from 'element-ui'
import { partyNewsInfo } from '@/api/comprehensive'
import vueQuillEditor from '../../components/vue-quill-editor/index.vue';
export default {
    components: {
        vueQuillEditor,
    },
    data() {
        return {
            edit: false,
            passwordForm: {},
            addForm: {
                title: '',
                content: ''
            },
            rules: {
                title: [{ required: true, message: '请填写', trigger: 'blur' }],
                content: [{ required: true, message: '请填写', trigger: 'blur' }],
            },
            isEdit: true,
        }
    },
    mounted() {
        this.isEdit = this.$route.query.isEdit
        if (this.isEdit === 'edit' || this.isEdit === 'view') {
            this.getDetail(this.$route.query.id)
        }
    },
    methods: {
        async getDetail(id) {
            let { result } = await partyNewsInfo('queryDetail', { id: id })
            this.addForm.title = result.title
            this.addForm.content = result.content
            this.addForm.id = result.id
            this.$refs.vueQuillEditor.content = result.content
        },
        handleQuillEditor(editor) {
            this.addForm.content = editor.html
        },
        newOldFormContrast(newForm) {
            Object.keys(this.addForm).forEach(key => {
                this.addForm[key] = newForm[key]
            })
            this.addForm.id = newForm.id
        },
        closeData() {
            this.$router.push('/partyBuilding/partyNewInfo')
        },
        addEventForm() {
            this.$refs['addForm'].validate(async (valid) => {
                if (valid) {
                    if (this.isEdit === 'edit') {
                        let res = await partyNewsInfo('update', this.addForm)
                        if (res.code === 0) {
                            Message.success('编辑成功！')
                            this.closeData()
                            await this.getData()
                        } else {
                            Message.warning({ message: res.message })
                        }
                    } else {
                        let res = await partyNewsInfo('add', this.addForm)
                        if (res.code === 0) {
                            Message.success('新增成功！')
                            this.closeData()
                            await this.getData()
                        } else {
                            Message.error(res.message)
                        }
                    }
                }
            })
        },
    }
}
</script>
<style>
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
    margin-left: 10px;
    font-size: 20px;
    cursor: pointer;
}
</style>